<template lang="pug">
    div
        f-dialog-confirm(v-model="dialog" :message="message" :events="events"
            v-on:reinquiry="doReinquiry" v-on:reverse="doReverse" 
            v-on:billingTransaction="doTransaction" v-on:dialog="dialog = $event" )
        v-data-table(
            hide-default-footer 
            :headers="headers" 
            :items="listData" 
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            :page.sync="page"
        )
            template(v-slot:top="{item}")
                 div(class="caption font-weight-bold primary white--text text-center justify-center") DATA POTONGAN
            template(v-slot:item.kodeMap="{item}")
                v-chip(small :color="validBilling(item) ? 'info' : 'error'" dark) {{ item.kodeMap }} - {{ item.namaMap }}
            template(v-slot:item.status="{item}")
                v-chip(small v-if="item.tipeTransaksi != 'TRANSFER' && item.status" :color="item.status == 'BERHASIL' ? 'info' : item.status == 'GAGAL' ? 'error' : 'warning'" dark) {{ item.status }}
            template(v-slot:item.nilai="{item}")
                div {{ item.nilai | decimalformat }}
            template(v-slot:item.action="{item}")
                v-layout(wrap justify-center menu-btn-sm my-1)
                    f-button-option(v-if="item.tipeTransaksi != 'TRANSFER'"
                        :reinquiry="reinquiry && item.tipeTransaksi == 'MPN' && item.status == 'REINQUIRY'"
                        :reverse="reverse && item.tipeTransaksi == 'MPN' && item.status == 'GAGAL_EC'"
                        :view="item.tipeTransaksi == 'MPN' && item.additionalData.billing"
                        :createBill=" !validBilling(item)"
                        :process="billingTransaction && item.tipeTransaksi == 'MPN' && (item.status == 'AKTIF' || item.status == 'GAGAL') || (item.additionalData.productCode.includes('CTAS')&& (item.status == 'AKTIF' || item.status == 'GAGAL') )"
                        :update="billingUpdate && item.tipeTransaksi == 'MPN' && item.status == 'UBAH_BILLING'"
                        :viewPhri="item.tipeTransaksi == 'PAD' && item.additionalData.productCode.includes('PHRI')"
                        v-on:reinquiry="confirmReinquiry(item)" v-on:reverse="confirmReverse(item)"
                        v-on:view="detail(item)" v-on:viewPhri="detailPhri(item)" v-on:update="updateBilling(item)"
                        v-on:createBill="createBilling(item)" v-on:process="confirmTransaction(item)"
                    )
        div(class="text-xs-center")
          v-pagination(v-model="page" :length="pageCount")
</template>
<script>
export default {
    name: "FKasdaPotonganTable",
    props: ["data", "edit", "reinquiry", "reverse", "billingTransaction", "billingUpdate"],
    data() {
        return {
            headers: [
                {text: 'Kode Map', value: 'kodeMap', sortable: false, width: "50%", class: "primary--text"},
                {text: '', value: 'status', sortable: false, width: "10%", class: "primary--text"},
                {text: 'Nominal', align: "right", value: 'nilai', sortable: false, width: "25%", class: "primary--text"},
                {text: '', value: 'action', sortable: false, width: "110px"},
            ],
            listData: [],
            itemsPerPage: 5,
            criteria: "",
            pageCount: 0,
            page: 1,
            dialog: false,
            message: "Apakah anda yakin akan melakukan reinquiry transaksi ?",
            events: "reinquiry",
            item: null
        }
    },
    mounted() {
        this.listData = this.data || [];
        console.log('mounted');
    },
    watch: {
        data(val) {
            this.listData = val || [];
        }
    },
    methods: {
        validBilling(item) {
            if (item.tipeTransaksi == "MPN") {
                if (item.idBilling) {
                    return true;
                } else {
                    return false;
                }
            }else {
                return true;
            }
        },
        confirmReinquiry(item) {
            // if (item.additionalData.billing.tanggalTransaksi != this.$options.filters.localdate(new Date())) {
            //     this.$message.error("Reinquiry hanya bisa dilakukan di hari yang sama");
            // } else {
                this.dialog = true;
                this.message = "Apakah anda yakin akan melakukan reinquiry transaksi ?";
                this.events = "reinquiry";
                this.item = item;
            // }
        },
        confirmReverse(item){
            if (item.additionalData.billing.tanggalTransaksiBank != this.$options.filters.localdate(new Date())) {
                this.$message.error("Reversal hanya bisa dilakukan di hari yang sama");
            } else {
                this.dialog = true;
                this.message = "Apakah anda yakin akan melakukan reversal transaksi ?";
                this.events = "reverse";
                this.item = item;
            }
        },
        confirmTransaction(item){
            this.dialog = true;
            this.message = "Apakah anda yakin akan melakukan transaksi potongan?";
            this.events = "billingTransaction";
            this.item = item;
        },
        doReinquiry() {
            this.$progress.show(true);
            this.$http.post("api/kasda/reinquiry",
                {
                    requestId: this.item.requestId
                })
            .then(success => {
                this.$message.success("Data berhasil di reinquiry");
                this.$emit("reset");
            }, err => {
                this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
        },
        doReverse() {
            this.$progress.show(true);
            this.$http.post("api/agg-kasda/reverse/deduction", 
                {
                    requestId: this.item.requestId,
                    reason: 'Reverse journal [' + this.item.requestId + '] - [' + this.item.billnum + ']'
                })
            .then(success => {
                this.$message.success("Data berhasil di reversal");
                this.$emit("reset");
            }, err => {
                this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
        },
        doTransaction() {
            this.$emit("transaction", this.item);
        },
        detail(item){
            this.$emit("detail", item);
        },
        detailPhri(item){
          this.$emit("detailPhri", item);
        },
        createBilling(item){
            this.$emit("createBilling", item);
        },
        updateBilling(item){
            this.$emit("updateBilling", item);
        },
    },
}
</script>